import {
  Card,
} from 'react-bootstrap';
import Header from '../components/Header';

const RegistrationFailure = () => {

  return (
    <>
    <span className="mt-3 ms-auto me-auto" style={{width:"80%", maxWidth:"80%"}}>
      <Header>
        Shelterly User Account Registration Failed
      </Header>
      <div className="row mt-1">
        <div className="col-8 d-flex">
          <Card className="border rounded d-flex" style={{width:"100%"}}>
            <Card.Body>
              <span>The access link used is no longer valid. Please contact a system administrator for help.</span>
            </Card.Body>
          </Card>
        </div>
      </div>
    </span>
    </>
  );
};

export default RegistrationFailure;
